import type React from 'react';
import { useCallback } from 'react';

import clsx from 'clsx';

import { twMerge } from '../../../utils/twMerge';
import { IconButton } from '../IconButton';
import { CopyIcon } from '../Icons';
import { Body } from '../LegacyText';
import Tooltip from '../Tooltip';

export interface CopyBoxProps extends React.HTMLAttributes<HTMLDivElement> {
  copyText: string;
}

const CopyBox: React.FC<CopyBoxProps> = ({ copyText, className }) => {
  const handleCopy = useCallback(() => {
    navigator.clipboard.writeText(copyText);
  }, [copyText]);
  return (
    <div
      className={twMerge(
        clsx(
          'cursor-default flex gap-xs2 items-center justify-between p-sm1 rounded-medium',
          className,
        ),
      )}
    >
      <Body>{copyText}</Body>
      <Tooltip
        content="Copied to clipboard"
        data-test-id="copy-btn"
        trigger={['click']}
      >
        <IconButton data-test-id="copy-button" onClick={handleCopy}>
          <CopyIcon />
        </IconButton>
      </Tooltip>
    </div>
  );
};

export default CopyBox;
